import React, { useState, useEffect } from "react";
import { Modal, Radio, Button, Tag, message } from "antd";
import Day from "react-calendar/dist/cjs/MonthView/Day.js";

const ChooseDays = ({
  open,
  onClose,
  onSave,
  activeComboId,
  activeChildId,
  parentCombinations,
  parentCombinationsV2,
  scheduleTypeOptions,
  sameScheduleForAll,
}) => {
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [scheduleType, setScheduleType] = useState();
  const [parent1Days, setParent1Days] = useState([]);
  const [parent2Days, setParent2Days] = useState([]);

  console.log(parent2Days, parentCombinationsV2);

  // const [sameScheduleForAll, setsameScheduleForAll] = useState(sameScheduleForAll);
  console.log(sameScheduleForAll, "sameScheduleForAll");

  const combo = parentCombinations.find(
    (c) => (c?.id || c?.coparent_combination_id) == activeComboId
  );
  let child;
  if (sameScheduleForAll) {
    child = combo?.children[0];
  } else {
    child = combo?.children?.find(
      (c) => (c?.id || c?.child_id) === activeChildId
    );
  }
  // console.log("combo in days",combo)

  const parent1Color =
    (typeof child?.parent1Color === "string"
      ? child?.parent1Color
      : child?.parent1Color?.name || combo?.parent1?.color?.value) ||
    (typeof combo?.parent1?.color === "string"
      ? combo?.parent1?.color
      : combo?.parent1?.color?.value || combo?.parent1?.color?.name) ||
    "#9A4FE0";

  const parent2Color =
    (typeof child?.parent2Color === "string"
      ? child?.parent2Color
      : child?.parent2Color?.name || combo?.parent2?.color?.value) ||
    (typeof combo?.parent2?.color === "string"
      ? combo?.parent2?.color
      : combo?.parent2?.color?.value || combo?.parent2?.color?.name) ||
    "#4EC3E0";
  const [scheduleTypeID, setScheduleTypeID] = useState();
  useEffect(() => {
    if (!combo) return;

    // Log for debugging
    // console.log("combo", combo, sameScheduleForAll);

    // Set scheduleTypeID based on whether it's the same schedule for all
    if (sameScheduleForAll) {
      setScheduleTypeID(Number(combo.children[0]?.schedule_type_id)); // Use combo's scheduleType when sameScheduleForAll is true
    } else {
      setScheduleTypeID(
        Number(child?.scheduleType?.id || child?.schedule_type_id)
      ); // Use child's scheduleType when not sameScheduleForAll
    }

    // Update sameScheduleForAll

    // Set the parent days based on the schedule
    if (sameScheduleForAll) {
      setParent1Days(combo.parent1?.days || []);
      setParent2Days(combo.parent2?.days || []);
    } else {
      setParent1Days(
        Array.isArray(child?.parent1Days) ||
          (child?.parent1 != {} &&
            child?.parent1?.days &&
            child?.parent1?.days?.length)
          ? child?.parent1?.days?.map((item) => item.day)
          : [] || []
      );
      setParent2Days(
        Array.isArray(child?.parent2Days) ||
          (child?.parent2 != {} &&
            child?.parent2?.days &&
            child?.parent2?.days?.length)
          ? child?.parent2?.days?.map((item) => item.day)
          : [] || []
      );
    }
  }, [activeComboId, activeChildId, parentCombinationsV2, sameScheduleForAll]);

  useEffect(() => {
    if (!combo) return;

    // scheduleType logic
    if (sameScheduleForAll) {
      setScheduleTypeID(Number(combo.children[0]?.schedule_type_id));
    } else {
      setScheduleTypeID(
        Number(child?.scheduleType?.id || child?.schedule_type_id)
      );
    }

    // --- Parent 1 days ---
    let p1Days = [];
    if (child?.parent1?.apply_same_time_all_days) {
      p1Days = child?.parent1?.selected_days || [];
    } else if (Array.isArray(child?.parent1Days)) {
      p1Days = child.parent1Days;
    } else if (Array.isArray(child?.parent1?.days)) {
      p1Days = child.parent1.days.map((d) => d.day || d);
    } else if (Array.isArray(combo?.parent1?.days)) {
      p1Days = combo.parent1.days.map((d) => d.day || d);
    }
    setParent1Days(p1Days);

    // --- Parent 2 days ---
    let p2Days = [];
    if (child?.parent2?.apply_same_time_all_days) {
      p2Days = child?.parent2?.selected_days || [];
    } else if (Array.isArray(child?.parent2Days)) {
      p2Days = child.parent2Days;
    } else if (Array.isArray(child?.parent2?.days)) {
      p2Days = child.parent2.days.map((d) => d.day || d);
    } else if (Array.isArray(combo?.parent2?.days)) {
      p2Days = combo.parent2.days.map((d) => d.day || d);
    }
    setParent2Days(p2Days);
  }, [activeComboId, activeChildId, parentCombinationsV2, sameScheduleForAll]);

  const handleParent1Click = (day) => {
    setParent1Days((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      return safePrev.includes(day)
        ? safePrev.filter((d) => d !== day)
        : [...safePrev, day];
    });

    setParent2Days((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      return safePrev.filter((d) => d !== day);
    });
  };

  const handleParent2Click = (day) => {
    if (!parent1Days.includes(day)) {
      setParent2Days((prev) => {
        const safePrev = Array.isArray(prev) ? prev : [];
        return safePrev.includes(day)
          ? safePrev.filter((d) => d !== day)
          : [...safePrev, day];
      });
    }
  };

  const onScheduleTypeChange = (e) => {
    const newType = e.target.value;
    setScheduleType(newType);
    setScheduleTypeID(newType);

    if (newType !== 42) {
      setParent1Days([]);
      setParent2Days([]);
    }
  };

  const renderDayTags = (
    selectedDays,
    onClick,
    disabledDays = [],
    color = "#9A4FE0"
  ) => (
    <div
      style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}
    >
      {daysOfWeek.map((day) => {
        const isSelected =
          Array.isArray(selectedDays) && selectedDays.includes(day);
        const isDisabled =
          Array.isArray(disabledDays) && disabledDays.includes(day);
        const isCyan = color === "#4EC3E0";

        const tagStyles = {
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.4 : 1,
          padding: "5px 16px",
          fontWeight: 500,
          userSelect: "none",
          color: isSelected ? color : "#000000",
          backgroundColor: isSelected
            ? isCyan
              ? "#E6FAFC"
              : "#FEF1FE"
            : "#F6F6F6",
          border: isSelected ? `1px solid ${color}` : "1px solid #E4E4E7",
        };

        return (
          <Tag
            key={day}
            onClick={() => !isDisabled && onClick(day)}
            style={tagStyles}
          >
            {day}
          </Tag>
        );
      })}
    </div>
  );

  const getScheduleLabel = () => {
    if (scheduleType === 40) return "Alternate Weeks";
    if (scheduleType === 41) return "2-2-3 Rotations";
    return `<strong>Parent 1:</strong> ${parent1Days.join(
      ", "
    )} <br> <strong>Parent 2:</strong> ${parent2Days.join(", ")}`;
  };

  const handleSave = () => {
    if (scheduleTypeID === 42) {
      const combinedDays = [...new Set([...parent1Days, ...parent2Days])];
      // return message.error("Please assign at least one day to both parents");
      if (combinedDays.length !== daysOfWeek.length) {
        Modal.error({
          title: "Missing Days Selection",
          content:
            "All 7 days of the week must be covered between both parents. Please assign the remaining days.",
        });
        return;
      }

      const overlap = parent1Days.filter((day) => parent2Days.includes(day));
      if (overlap.length > 0) {
        Modal.error({
          title: "Overlap Detected",
          content: `The following days are assigned to both parents: ${overlap.join(
            ", "
          )}. Each day must belong to only one parent.`,
        });
        return;
      }
    }

    const schedule = {
      id: scheduleTypeID,
      label: getScheduleLabel(),
    };

    onSave(parent1Days, parent2Days, schedule, sameScheduleForAll);
    onClose();
  };
  // console.log("parent1Days ::parent2Days", parent1Days, parent2Days)
  // console.log("scheduleTypeID",scheduleTypeID,typeof(scheduleTypeID))
  return (
    <Modal
      title={
        sameScheduleForAll
          ? "Select Days for all children"
          : `Select Days for ${child?.name || ""}`
      }
      open={open}
      onCancel={onClose}
      maskClosable={false}
      footer={null}
    >
      <div style={{ marginTop: "30px" }}>
        <Radio.Group
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginTop: 12,
          }}
          onChange={onScheduleTypeChange}
          value={scheduleTypeID}
          options={scheduleTypeOptions}
        />

        {scheduleTypeID === 42 && (
          <>
            <div style={{ marginTop: "30px" }}>
              <div className="show-parent-dayoff">
                {child?.parent1Name || combo?.parent1?.name || "Parent 1"}
                <div
                  className="color"
                  style={{
                    marginLeft: 6,
                    backgroundColor: parent1Color,
                  }}
                ></div>
              </div>
              {renderDayTags(
                parent1Days,
                handleParent1Click,
                parent2Days,
                parent1Color
              )}
            </div>

            <div>
              <div className="show-parent-dayoff">
                {child?.parent2Name || combo?.parent2?.name || "Parent 2"}
                <div
                  className="color-parent2"
                  style={{
                    marginLeft: 6,
                    backgroundColor: parent2Color,
                  }}
                ></div>
              </div>
              {renderDayTags(
                parent2Days,
                handleParent2Click,
                parent1Days,
                parent2Color
              )}
            </div>
          </>
        )}

        <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
          <Button type="primary" className="modal-btn" onClick={handleSave}>
            Save
          </Button>
          <Button className="modal-btn-skip" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChooseDays;
